import React from 'react';
import { Navigate } from 'react-router-dom';
import { hasRole, hasPermission } from '../utils/rbac';

function ProtectedRoute({ 
  isAuthenticated, 
  user, 
  requiredRole, 
  requiredPermission, 
  children 
}) {
  // Check authentication - if not authenticated, redirect to login
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // If authenticated but user data is still loading, show loading or allow access
  // (user data will be available from localStorage)
  if (!user) {
    return <div className="loading">Loading...</div>;
  }

  // Check required role
  if (requiredRole && !hasRole(user.user_type, requiredRole)) {
    return <Navigate to="/" replace />;
  }

  // Check required permission
  if (requiredPermission && !hasPermission(user.user_type, requiredPermission)) {
    return <Navigate to="/" replace />;
  }

  return children;
}

export default ProtectedRoute;
